import React from "react";
import { Formik, FormikProps } from "formik";
import { IManagementStore, ISelectItem } from "@src/Stores/Management/types";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { STMainWrapper, STSelectLocationWrapper, STFormSimpleSelect, STGrid } from "./styles";
import _ from "lodash";
import { Location } from "@src/Interfaces/Entity/Location";
import CrewTable from "./CrewTable/CrewTable";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  management?: IManagementStore;
  auth?: IAuthStore;
}

interface IFormValues {
  location: string;
}

@inject("auth", "management")
@observer
export default class Crew extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable location: Location = null;
  initialValues: IFormValues = {
    location: "",
  };
  sessionStorageKey: string = "locationSettingsLocationId";

  async componentDidMount() {
    document.title = Values.getLocalizationValue("positionManagement");

    await Promise.all([
      this.props.management.getActiveLocations(),
      this.props.management.getActivePositions(),
      this.props.management.getActivePersons(),
    ]);

    const sessionData = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    const initialLocationId =
      sessionData && sessionData.sessionId === this.props.auth.user.session
        ? sessionData.locationId
        : this.props.auth.user.location.id;
    this.initialValues.location = initialLocationId;
    let location = this.getLocation(initialLocationId);
    this.location = _.cloneDeep(location);

    this.isLoading = false;
  }

  getLocations = () => {
    return _.orderBy(this.props.management.activeLocations, "name");
  };

  getLocation = (locationId: string) => {
    return this.props.management.activeLocations.find(x => x.id == locationId);
  };

  onLocationChange = (item: any, formikProps: FormikProps<IFormValues>) => {
    formikProps.setFieldValue("location", item);
    let location = this.getLocation(item);
    this.location = _.cloneDeep(location);
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify({ locationId: item, sessionId: this.props.auth.user.session })
    );
  };

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }
    let locations = this.getLocations();
    return (
      <Grid container justify="center">
        <STMainWrapper>
          <Formik
            initialValues={this.initialValues}
            onSubmit={() => {}}
            render={(formikProps: FormikProps<IFormValues>) => (
              <form onSubmit={formikProps.handleSubmit}>
                <Grid container>
                  <Grid xs item>
                    <STPageHeader>{Values.getLocalizationValue("crew")}</STPageHeader>
                  </Grid>
                  <Grid
                    xs={3}
                    item
                    style={{
                      visibility: this.props.auth.user.location.primary ? "visible" : "hidden",
                    }}
                  >
                    <FormSimpleSelect<IFormValues, Location>
                      fieldName="location"
                      items={locations}
                      keyAsTitle="name"
                      keyAsValue="id"
                      keyAsDescription="description"
                      formikProps={formikProps}
                      label={Values.getLocalizationValue("location")}
                      onChange={(item: any) => this.onLocationChange(item, formikProps)}
                    />
                  </Grid>
                </Grid>
                {this.location && (
                  <div>
                    <Grid container justify="center">
                      <CrewTable location={this.location} noTitle={true} />
                    </Grid>
                  </div>
                )}
              </form>
            )}
          />
        </STMainWrapper>
      </Grid>
    );
  }
}
